import React from "react";
import { connect } from "react-redux";

import { getSchoolTermIDList, getSchoolByID } from "state/teachers/selectors";

import List from "components/List";
import PlaceholderCard from "components/teachers/PlaceholderCard";
import Term from "components/teachers/term_calendar/Term";

class SchoolTermList extends React.Component {
  
  render() {
    
    const { termIDList, school } = this.props;
    
    const placeholder = <PlaceholderCard school={school} objectName="terms" />;
    
    return (
      <List className="term-list" placeholder={placeholder}>
        { termIDList.map(termID => <Term key={termID} termID={termID} />) }
      </List>
    );
    
  }
  
}

export default connect(
  (state, { schoolID }) => ({
    termIDList: getSchoolTermIDList(state, schoolID),
    school: getSchoolByID(state, schoolID)
  })
)(SchoolTermList);



// WEBPACK FOOTER //
// ./src/components/teachers/term_calendar/SchoolTermList.js